<template>
    <div :class="cn('relative rounded-md bg-[#f5f5f5] dark:bg-[#202226] mt-[5px] transition-transform hover:translate-y-[-5px] pt-8 pb-4 px-4', $attrs.class!)" v-bind="$attrs">
        <NuxtImg class="mx-auto object-contain h-24" :src="icon" :alt="name" loading="lazy" />
        <div class="mt-6">
            <p class="text-xs font-medium text-gray-800 dark:text-white">{{ category }}</p>
            <h2 class="mt-0.5 font-bold text-gray-800 dark:text-white truncate">{{ name }}</h2>
            <p class="mt-0.5 text-xs font-medium text-gray-800 dark:text-white">{{ rarity }}</p>
        </div>
        <div class="grid grid-flow-col auto-cols-auto font-semibold text-gray-800 dark:text-white text-sm mt-3">
            <div class="text-left">
                <span>Old</span>
            </div>
            <div class="text-right">
                <span>{{ oldValueApplicable ? formatNumber(oldValue) : 'N/A' }}</span>
            </div>
        </div>
        <div class="grid grid-flow-col auto-cols-auto font-semibold text-gray-800 dark:text-white text-sm mt-2">
            <div class="text-left">
                <span>New</span>
            </div>
            <div class="text-right">
                <span v-if="newValueApplicable">
                    {{ formatNumber(newValue) }} <i class="fa-solid" :class="{'fa-down-long text-red-600': oldValue! > newValue!, 'fa-up-long text-green-500': newValue! > oldValue!}"></i>
                </span>
                <span v-else>N/A <i class="fa-solid fa-down-long text-red-600"></i></span>
            </div>
        </div>
        <p class="mt-3 dark:text-white text-[13px] font-semibold">{{ $dayjs(date).fromNow() }}</p>
    </div>
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils'

defineProps({
    icon: {
        type: String,
        required: true,
    },
    name: {
        type: String,
        required: true
    },
    category: {
        type: String,
        required: true
    },
    rarity: {
        type: String,
        required: true
    },
    value: Number,
    oldValue: Number,
    oldValueApplicable: Boolean,
    newValue: Number,
    newValueApplicable: Boolean,
    date: String
})

defineOptions({
    inheritAttrs: false
})
</script>